module.exports = __webpack_public_path__ + "media/images/brussels/offers/digital-voucher-840591d7005ee815d02563004b1b8ae8.jpg";